module.exports = __webpack_public_path__ + "static/media/about__persone.cb1c92d3.jpg";